import {
  ModelCreateModal,
  ModelEditModal,
  ModelFieldGroup
} from '@rhino-project/ui-heroui';
import { useWatch } from 'react-hook-form';
import { useModel } from '@rhino-project/core/hooks';
import { ComponentProps } from 'react';
import { RhinoPathEntries } from '@rhino-project/core';

const RenderIfNotPlayer = (props: ComponentProps<typeof ModelFieldGroup>) => {
  const playerContact = useWatch({ name: 'player_contact' });

  if (playerContact) return null;

  return <ModelFieldGroup {...props} />;
};

const paths: RhinoPathEntries<'contact'> = [
  'player_contact',
  // eslint-disable-next-line @eslint-react/no-missing-key
  <RenderIfNotPlayer path="name" />,
  // eslint-disable-next-line @eslint-react/no-missing-key
  <RenderIfNotPlayer path="relationship" />,
  'primary',
  'email',
  'phone',
  'note'
];

interface ContactSidebarFormProps {
  action?: string;
  [key: string]: unknown;
}

const ContactSidebarForm = ({
  action = 'create',
  ...props
}: ContactSidebarFormProps) => {
  const model = useModel('contact');
  const isCreate = action === 'create';

  if (isCreate) {
    return <ModelCreateModal {...props} model={model} paths={paths} />;
  }

  return <ModelEditModal {...props} model={model} paths={paths} />;
};

export default ContactSidebarForm;
